import { useMutation, UseMutationOptions } from 'react-query';

type ResultData =
  | { client_secret: string }
  | { message: string }
  | { payment_intent_client_secret: string; require_action: boolean }
  | { errors: string[] };

type MutationError = Error | Response;

type Variables = {
  price_id: string;
};

type MutationOptions = UseMutationOptions<ResultData, MutationError, Variables>;

const subscriptionCheckoutMutation: MutationOptions = {
  mutationFn: async (fields) => {
    const response = await fetch('/api/v1/subscriptions/subscribe', {
      body: JSON.stringify(fields),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const data = await response.json();

    if (!response.ok) {
      
      const firstErrorMessage = data.payment_error

      const errorMessage = firstErrorMessage
        ? firstErrorMessage
        : 'Subscription failed';

      const error = Object.assign(new Error(errorMessage), {
        errors: data.errors,
      });      
      throw error;
    }

    return data;
  },
};

export const useSubscriptionCheckout = (
  options?: Omit<MutationOptions, 'mutationFn'>,
) => {
  return useMutation({
    ...options,
    ...subscriptionCheckoutMutation,
  });
};
